<template>
    <el-dialog class="dialog" :visible="dialogs.workFunctionsRename" customClass="dialog_main" :append-to-body="true" :close-on-click-modal="false" @close="closeDialog()" @open="handleOpen">
        <div slot="title" class="dialog__head dialog__head_second">
            <div class="dialog__head-inner">
                <h3 class="dialog__title">Редактировать трудовую функцию</h3>
            </div>
        </div>

        <div slot="default" class="dialog__inner">
            <form
                action="#"
                class="dialog__form"
                @submit.prevent="renameWorkFunction($event)"
                autocomplete="off"
            >
                <div class="general-work-function__inner">
                    <div class="general-work-function__input-inner">
                        <input type="text" name="subcode" class="input general-work-function__input" placeholder="Код" v-model="newWorkFunction.subcode">

                        <span class="general-work-function__input-code">
                            {{ activeWorkFunction.code ? `${activeWorkFunction.code}/` : '' }}
                        </span>
                    </div>
                    
                    <input type="text" name="name" class="input" placeholder="Название" v-model="newWorkFunction.name">
                </div>

                <footer slot="footer" class="dialog__footer mt-24">
                    <div class="dialog__footer-inner">
                        <div class="dialog__footer-item"></div>
                        
                        <div class="dialog__footer-item">
                            <button type="submit" class="btn btn_action">
                                Применить
                            </button>
                        </div>
                    </div>
                </footer>
            </form>
        </div>
    </el-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

import constants from '@/constants.js';
import dialog from '@/mixins/dialog';

export default {
    mixins: [ dialog ],
    props: {
        isStandard: {
          type: Boolean,
          default: false,
          required: false,
        },
        activeWorkFunction: {
            required: true,
            type: Object,
            default: function() {
                return {}
            }
        }
    },
    data() {
        return {
            newWorkFunction: {
                name: '',
                subcode: '',
                code: ''
            }
        }
    },
    methods: {
        ...mapActions('editor', ['UPDATE_WORK_FUNCTION', 'UPDATE_WORK_FUNCTION_FOR_STANDARD']),

        closeDialog() {
            this.elDialogs.workFunctionsRename = false;
        },
        async renameWorkFunction(e) {
            const formData = new FormData(e.target);

            const params = this.newWorkFunction
            params.workFunctionId = this.newWorkFunction.id

            for (const pair of formData.entries()) {
                params[pair[0]] = pair[1];
            }

            if (this.isStandard) {
              await this.UPDATE_WORK_FUNCTION_FOR_STANDARD(params);
            } else {
              await this.UPDATE_WORK_FUNCTION(params)
            }


            this.closeDialog()
        },
        handleOpen() {
            this.$nextTick(() => {
                this.newWorkFunction = JSON.parse(JSON.stringify(this.activeWorkFunction));
            });
        }
    },
    mounted() {
        this.newWorkFunction = JSON.parse(JSON.stringify(this.activeWorkFunction));
    }
}
</script>
